<template>
  <div id="app">
    <vue-ins-progress-bar></vue-ins-progress-bar>
    <router-view></router-view>  
  </div>  
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
